export default "__VITE_ASSET__CUGkRN_9__"